'use client';

import { useState } from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';

export interface Props {
  text: string;
  active: boolean;
}

const MaintenanceBar = ({ text, active }: Props) => {
  const [visible, setIsVisible] = useState(active);

  if (!visible) return <></>;

  return (
    <div className="flex items-center justify-between bg-[#416BD8] p-4 text-[14px] text-white md:px-6 lg:px-5 lg:text-[16px] xl:px-12">
      <p>{text}</p>
      <CloseIcon className="size-6 cursor-pointer" onClick={() => setIsVisible(false)} />
    </div>
  );
};

export default MaintenanceBar;
